import React from 'react';

import Stack from "@mui/joy/Stack";
import Card from "@mui/joy/Card";

import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";


import FancyHandsLogo from "./FancyHandsLogo";
// import DayOneLogo from "./DayOneLogo";
import Link from "components/Link";

import { BACKGROUND_GRADIENT_CSS } from '../constants';

export function CardTopStack( {size} : {size?: string}) {
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            spacing={0}
        >

                    { size !== 'small' &&
            <Box sx={{ width: 225 }}>
                <Link to={"/"}>
                    <FancyHandsLogo />
                </Link>
            </Box>

        }

        {/*
            <DayOneLogo />
          */}
            {size === 'small' ?
                null :

            <Stack spacing={0} pt={2} justifyItems="center" alignItems="center">
                <Typography level="title-lg">
                    The best {' '}
                    <Typography
                        color="success"
                        variant="soft"
                        sx={{ cursor: "default" }} >new
                    </Typography>
                    {' '} way to get things done
                </Typography>
                <Typography color="neutral" level="body-md">
                    From the ones who invented the old way
                </Typography>
            </Stack>
            }
        </Stack>
    );
}

export default function CardLoggedOut({children, size, hideLogo=false} : {children: React.ReactNode, size?: string, hideLogo?: boolean}) {
    return (
        <Stack
            width={"100vw"}
            height={"100vh"}
            direction="column"
            justifyContent="flex-start"
            // pt={5}
            alignItems="center"
            sx={{
                backgroundImage: BACKGROUND_GRADIENT_CSS,
                overflow: "auto"
            }}
        >
            <Card variant="soft"
                id="some-id"
                sx={{
                    maxWidth: 550,
                    m: { xs: 2, sm: 'auto' },
                    mt: { xs: 2, sm: 5 },
                }}
            >
                { !hideLogo &&
                    <CardTopStack size={size}  />
                }
                {children}
            </Card>

        </Stack>
    );
}
